<template>
  <div v-if="headers">
    <v-data-table
      :headers="headers"
      :items="details"
      hide-default-footer
      class="elevation-1"
      item-key="id"
      loading="true"
      v-model="selection"
    >
      <template slot="headers" slot-scope="props">
        <tr>
          <th v-for="(header, index) in headers" :key="index">
            <strong>{{ header.text }}</strong>
          </th>
          <th>
            <v-btn color="primary" @click="addNewRule">Add New Rule</v-btn>
          </th>
        </tr>
      </template>

      <template v-slot:items="{ item, headers }">
        <tr>
          <td
            :class="`text-xs-${name.align}`"
            v-for="(name, index) in headers"
            :key="index"
          >
            <span v-if="name.value == `amount`"
              >${{ item[name.value] | formatMoney }}</span
            >
            <span v-else>{{ item[name.value] }}</span>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: "ruleDetail",
  props: {
    details: {
      type: Array,
      required: true
    },
    ratePlanId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      selection: []
    };
  },
  methods: {
    addNewRule() {
      console.log(this.ratePlanId);
    }
  },
  computed: {
    headers: function() {
      return this.getHeaders({
        dealerLevelId: 0,
        dealerTypeId: 0,
        fixed: false,
        handsetOverride: false,
        amount: 0.0
      });
    }
  }
};
</script>

<style scoped></style>
